import { render, staticRenderFns } from "./TableView.vue?vue&type=template&id=744b0dab&scoped=true"
import script from "./TableView.vue?vue&type=script&lang=ts"
export * from "./TableView.vue?vue&type=script&lang=ts"
import style0 from "./TableView.vue?vue&type=style&index=0&id=744b0dab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744b0dab",
  null
  
)

export default component.exports